export const PRO_BADGE_LOCALE_CLASS_MAPPER = {
    'de-DE': 'german',
    'es': 'spanish',
    'fr-FR': 'french',
    'pt-BR': 'portuguese',
    'it-IT': 'italian',
    'nl-NL': 'dutch'
};
